export const isStringNotBlank = (
  str: string | undefined | null,
): str is string => !!str && str.trim() !== "";

export const trimIndent = (input: string): string => {
  // Split the input into lines.
  const lines = input.split("\n");

  // Calculate the common white space prefix.
  const minIndent = lines
    .filter((line) => line.trim() !== "")
    .reduce(
      (minIndent, line) => Math.min(minIndent, line.search(/\S/)),
      Infinity,
    );

  // Remove the common white space prefix from each line.
  const trimmedLines = lines.map((line) => line.slice(minIndent));

  // Join the lines back together.
  return trimmedLines.join("\n");
};

export const removeNonNumericCharacters = (input: string): string =>
  input.replace(/[^0-9.]/g, "");
